import { render } from "./InputField.vue?vue&type=template&id=85a76f08&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"

import "./InputField.vue?vue&type=style&index=0&id=85a76f08&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a76f08"]])

export default __exports__